var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8.25,
    fill: "white",
    stroke: "#FF505A",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30019 7.29644C8.02487 7.02112 7.57849 7.02112 7.30317 7.29644C7.02785 7.57176 7.02785 8.01814 7.30317 8.29346L8.99622 9.98652L7.28969 11.6931C7.01437 11.9684 7.01437 12.4148 7.28969 12.6901C7.56501 12.9654 8.01139 12.9654 8.28671 12.6901L9.99324 10.9835L11.7133 12.7036C11.9886 12.9789 12.435 12.9789 12.7103 12.7036C12.9856 12.4283 12.9856 11.9819 12.7103 11.7066L10.9903 9.98652L12.6968 8.27994C12.9722 8.00462 12.9722 7.55824 12.6968 7.28292C12.4215 7.0076 11.9751 7.0076 11.6998 7.28292L9.99324 8.9895L8.30019 7.29644Z",
    fill: "#FF505A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFilled);
export default __webpack_public_path__ + "static/media/delete-filled.341d0e345bc42de9e25b3df99117a1ab.svg";
export { ForwardRef as ReactComponent };